import React from 'react';
import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Button from "@/atomic/atoms/Button";

export default function FaqView({
  goBack,
  openedAccordion,
  setOpenedAccordion,
  infos,
  goToContact,
}: PropsView) {
  return (
    <div className="relative flex flex-1 flex-col w-full">
      <Header
        title="Perguntas frequentes"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-1 z-10 p-2 w-full flex justify-center h-full text-black h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div className={`w-full`}>
            <h2 className="text-black mt-6 font-bold text-2xl">Sobre o Free Flow</h2>
            {infos?.map((item, index) => (
              <div className="w-full mt-2" key={index}>
                <div className="w-full flex flex-row justify-between">
                  <p className="max-w-[calc(90%)] text-lg">{item?.title ?? ""}</p>
                  <button
                    type="button"
                    onClick={() => setOpenedAccordion(openedAccordion === index ? null : index)}>
                    <img
                      src={openedAccordion === index ? "/arrow-top.png" : "/arrow-bottom.png"}
                      width={32}
                      height={32}
                      alt={openedAccordion === index ? "Retrair" : "Expandir"}
                    />
                  </button>
                </div>
                {openedAccordion === index && item?.text?.split("\n")?.map?.((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
                <div className="h-px w-full bg-gray-300 mt-2 mb-2"/>
              </div>
            ))}
          </div>
          <Button
            title="Tenho uma dúvida"
            type="button"
            onClick={goToContact}
            isDisabled={false}
          />
        </article>
      </main>
    </div>
  );
}
